import { render, staticRenderFns } from "./FeaturesCustomURL.vue?vue&type=template&id=2806a272&lang=html&"
import script from "./FeaturesCustomURL.vue?vue&type=script&lang=js&"
export * from "./FeaturesCustomURL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports